import React, { useState, useEffect } from 'react';
import { useAdmin } from '../../context/AdminContext';
import axios from 'axios';
import toast from 'react-hot-toast';
import { Eye } from 'lucide-react';
import { ADMIN_BASE } from '../../utils/apiBase';

const API = ADMIN_BASE;

const AdminContactForms = () => {
  const { getAuthHeader } = useAdmin();
  const [contactForms, setContactForms] = useState([]);
  const [selectedContact, setSelectedContact] = useState(null);

  useEffect(() => {
    fetchContactForms();
  }, []);

  const fetchContactForms = async () => {
    try {
      const res = await axios.get(`${API}/contact-forms`, { headers: getAuthHeader() });
      setContactForms(res.data || []);
    } catch (error) {
      toast.error('Failed to fetch contact forms');
    }
  };

  return (
    <div>
      <h1 className="text-3xl font-bold text-gray-800 mb-6">Contact Forms</h1>

      {selectedContact && (
        <div className="bg-white rounded-lg shadow p-6 mb-6">
          <div className="flex justify-between items-start mb-4">
            <div>
              <h2 className="text-2xl font-bold">{selectedContact.name}</h2>
              <p className="text-gray-600">
                {selectedContact.timestamp ? new Date(selectedContact.timestamp).toLocaleString() : '-'}
              </p>
            </div>
            <button
              onClick={() => setSelectedContact(null)}
              className="text-gray-600 hover:text-gray-800"
            >
              Close
            </button>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
            <div className="bg-gray-50 p-4 rounded-lg">
              <p className="text-sm text-gray-600 mb-1">Email</p>
              <p className="font-semibold">{selectedContact.email}</p>
            </div>
            <div className="bg-gray-50 p-4 rounded-lg">
              <p className="text-sm text-gray-600 mb-1">Phone</p>
              <p className="font-semibold">{selectedContact.phone}</p>
            </div>
            <div className="bg-gray-50 p-4 rounded-lg md:col-span-2">
              <p className="text-sm text-gray-600 mb-1">Preferred Clinic</p>
              <p className="font-semibold">{selectedContact.clinic_location}</p>
            </div>
          </div>

          <div className="bg-gray-50 p-4 rounded-lg">
            <p className="text-sm text-gray-600 mb-2">Message</p>
            <p className="text-gray-800 whitespace-pre-wrap">{selectedContact.message}</p>
          </div>
        </div>
      )}

      <div className="bg-white rounded-lg shadow overflow-hidden">
        <table className="w-full">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-4 py-3 text-left">Name</th>
              <th className="px-4 py-3 text-left">Email</th>
              <th className="px-4 py-3 text-left">Phone</th>
              <th className="px-4 py-3 text-left">Clinic</th>
              <th className="px-4 py-3 text-left">Date</th>
              <th className="px-4 py-3 text-left">Actions</th>
            </tr>
          </thead>
          <tbody>
            {contactForms.map((form) => (
              <tr key={form.id} className="border-t">
                <td className="px-4 py-3">{form.name}</td>
                <td className="px-4 py-3">{form.email}</td>
                <td className="px-4 py-3">{form.phone}</td>
                <td className="px-4 py-3">{form.clinic_location}</td>
                <td className="px-4 py-3">
                  {form.timestamp ? new Date(form.timestamp).toLocaleDateString() : '-'}
                </td>
                <td className="px-4 py-3">
                  <button
                    onClick={() => setSelectedContact(form)}
                    className="text-blue-600 hover:text-blue-800"
                  >
                    <Eye size={18} />
                  </button>
                </td>
              </tr>
            ))}
            {contactForms.length === 0 && (
              <tr>
                <td colSpan="6" className="px-4 py-8 text-center text-gray-500">
                  No contact form submissions yet.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminContactForms;
